import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import reportWebVitals from './reportWebVitals';
import { CookieSetting } from "cookiesetting-component";

const appVersion = appversion.version;

let pathname = window.location.pathname.toLowerCase();

// Check if the pathname is "/homeownershipseminar" without a trailing slash
if (pathname === '/leadership' && !pathname.endsWith('/')) {
  // Redirect to the URL with the trailing slash
  window.location.href = `${window.location.href}/`;
} else if (pathname === '/leadership/') {
  // Redirect to the search URL
  let searchURL = window.location.href.toLowerCase();
  if (window.location.hostname === 'localhost') {
    searchURL = `http://${window.location.host}${pathname}search`;
  } else {
    searchURL = `https://${window.location.host}${pathname}search`;
  }
  window.location.href = searchURL;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASENAME} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} // If false, the library is disabled.
        isVerboseMode={false} // If true, the library writes verbose logs to console.
      >
        <App />
        <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      </CacheBuster>
      
    </BrowserRouter>
    </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
